import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core'
import { Router } from '@angular/router'
import { NotificationService } from '../../../services/notification.service'
import { MetabaseService } from 'src/app/services/metabase.service'
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
	selector: 'app-dashboard',
	templateUrl: './dashboard.component.html'
})
export class DashboardComponent implements OnInit {
	@ViewChild('metabaseIframe') iframe: ElementRef;
	public isLoading: boolean = false
	public metabaseUrl: SafeResourceUrl;

	constructor(
		public notificationService: NotificationService,
		private metabaseService: MetabaseService,
		private router: Router,
		private sanitizer: DomSanitizer
	) { }

	public ngOnInit(): void {
		this.isLoading = true

		const companyId: string = localStorage.getItem('companyId')
		this.metabaseService.getMetabaseEmbeddedUrl(companyId).subscribe(
			(iframeUrl: string) => {
				const safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(iframeUrl);
				this.metabaseUrl = safeUrl;
			},
			(err: any) => {
				this.notificationService.notify(err.error.message, err.error.code)
			}, () => {
				this.isLoading = false
			}
		)
	}

	public redirectToTreesComponent() {
		console.log('Inactive')
	}

	public redirectToDemands(event) {
		if (
			event.active[0]._view && event.active[0]._view.label === 'PENDENTES' ||
			event.active[0]._view.label === 'ATRASADAS' || event.active[0]._view.label === 'CANCELADAS'
		) {
			this.router.navigate(['/panel/scheduler'])
		} else if (
			event.active[0]._view && event.active[0]._view.label === 'ATENDIDAS' ||
			event.active[0]._view.label === 'REALIZADAS'
		) {
			this.router.navigate(['/panel/demandsHistory'])
		}
	}

	public redirectToHistoryInventory() {
		this.router.navigate(['/panel/historyInventory'])
	}

	public redirectToHistoryPlanting() {
		this.router.navigate(['/panel/planting/history-planting'])
	}

	public redirectToPlanting(event) {
		if (
			event.active[0]._view && event.active[0]._view.label === 'PENDENTES' ||
			event.active[0]._view.label === 'ATRASADAS' || event.active[0]._view.label === 'CANCELADAS'
		) {
			this.router.navigate(['/panel/planting/scheduler-planting'])
		} else if (
			event.active[0]._view && event.active[0]._view.label === 'ATENDIDAS' ||
			event.active[0]._view.label === 'REALIZADAS'
		) {
			this.router.navigate(['/panel/planting/history-planting'])
		}
	}
}